/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_NextInputs */

const en_portal_rail_next = /** @type {(inputs: Portal_Rail_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pl_portal_rail_next = /** @type {(inputs: Portal_Rail_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następne`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Portal_Rail_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_next = /** @type {((inputs?: Portal_Rail_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_next(inputs)
	return en_portal_rail_next(inputs)
});